<div class="personal-visit-action-bar">
    <div class="group">
        <div class="buttons">
            <button mat-icon-button (click)="newPersonalVisitorVisit()"
                [matTooltip]="'Besucher anmelden' | translate: ['tmc.visit.overview.visitors.action.register.visitor.tooltip', translationService.language]"
                [disabled]="!isAddEnabled">
                <sc-icon iconClass="fa-plus"></sc-icon>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-icon-button (click)="registerEntranceForVisitReservation()"
                [matTooltip]="'Vorangekündiger Besucher anmelden' | translate: ['tmc.visit.overview.visitors.action.register.visitreservation.tooltip', translationService.language]"
                [disabled]="!isRegisterEnabled">
                <sc-icon iconClass="fa-user-check"></sc-icon>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-icon-button (click)="editPersonalVisit()"
                [matTooltip]="'Besuch bearbeiten' | translate: ['tmc.visit.overview.visitors.action.edit.tooltip', translationService.language]"
                [disabled]="!isEditEnabled">
                <sc-icon iconClass="fa-edit"></sc-icon>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-icon-button (click)="deletePersonalVisit()"
                [matTooltip]="'Besuch löschen' | translate: ['tmc.visit.overview.visitors.action.delete.tooltip', translationService.language]"
                [disabled]="!isDeleteEnabled">
                <sc-icon iconClass="fa-trash"></sc-icon>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-icon-button (click)="leave()"
                [matTooltip]="'Abmelden' | translate: ['tmc.visit.overview.visitors.action.leave.tooltip', translationService.language]"
                [disabled]="!isLeaveEnabled">
                <sc-icon iconClass="fa-door-closed"></sc-icon>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-icon-button [disabled]="!isHandoutSupplementaryEquipmentEnabled"
                (click)="handoutSupplementaryEquipment()"
                [matTooltip]="'Handout Supplementary Equipment' | translate: ['tmc.visit.overview.action.handoutSupplementaryEquipment', translationService.language]">
                <sc-icon iconClass="fa-upload"></sc-icon>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-icon-button [disabled]="!isTakeBackSupplementaryEquipmentEnabled"
                (click)="takeBackSupplementaryEquipment()"
                [matTooltip]="'Take back Supplementary Equipment' | translate: ['tmc.visit.overview.action.takeBackSupplementaryEquipment', translationService.language]">
                <sc-icon iconClass="fa-download"></sc-icon>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-icon-button [disabled]="!resendInvitationEnabled"
                (click)="resendInvitation()"
                [matTooltip]="'Resend invitation mail' | translate: ['tmc.visit.overview.action.resendInvitationMail', translationService.language]">
                <sc-icon iconClass="fa-envelope"></sc-icon>
            </button>
            <ng-container *ngIf="isPrintVisitorIdentityCardConfigured">
                <sc-content-spacer></sc-content-spacer>
                <button mat-icon-button [disabled]="!isPrintVisitorIdentityCardEnabled"
                    (click)="printVisitorIdentityCard()"
                    [matTooltip]="'Print visitor identity card' | translate: ['tmc.visit.overview.action.printVisitorIdentityCard', translationService.language]">
                    <sc-icon iconClass="fa-id-card"></sc-icon>
                </button>
            </ng-container>
            <ng-container *ngIf="!isPrintVisitorIdentityCardConfigured">
                <sc-content-spacer></sc-content-spacer>
                <button mat-icon-button [disabled]="!isCreateVisitorIdentityCardPDFEnabled"
                    (click)="createVisitorIdentityCardPDF()"
                    [matTooltip]="'Print visitor identity card' | translate: ['tmc.visit.overview.action.createVisitorIdentityCardPDF', translationService.language]">
                    <sc-icon iconClass="fa-id-badge"></sc-icon>
                </button>
            </ng-container>
            <sc-content-spacer></sc-content-spacer>
            <button mat-icon-button (click)="emergencyCall()" [disabled]="!isEmergencyCallEnabled"
              [matTooltip]="'emergency call' | translate: ['tmc.visit.overview.action.emergencyCall', translationService.language]">
              <sc-icon iconClass="fa-siren-on"></sc-icon>
            </button>
        </div>
    </div>
</div>